<!--赖传峰-->
<!--2022/2/10-->
<script
  lang="ts"
  setup
>
import {
  computed,
  useNuxtApp,
} from '#imports'
import { SupportLocale } from '~/types/enum'

const { locale, locales } = useNuxtApp().$i18n

const availableLocales = computed(() => (locales.value as Locales).filter(i => i.code !== locale.value))

const setLocale = (code: SupportLocale) => useNuxtApp().$i18n.setLocale(code)

</script>

<template>
  <ul>
    <li
      v-for="el in availableLocales"
      :key="el.code"
    >
      <a
        class="pp-link-button"
        href="javascript:void(0);"
        @click="setLocale(el.code)"
      >
        {{ el.name }}
      </a>
    </li>
  </ul>
</template>
<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

li {
  border-radius: 4px;

  a {
    height: 48px;
    justify-content: left;
    text-indent: 8px;
  }

  &:hover {
    background: var(--color-hover);
  }

  &.active {
    background: var(--color-active);
  }
}

@media screen and (max-width: @mobile-break-width) {
  a {
    font-size: 13px;
    height: 36px;
    justify-content: flex-start;
    padding-left: 24px;
  }
}
</style>
